import { Flex } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { DocumentHtmlPreview } from '@features/invoices/elements/DocumentHtmlPreview'
import { InvoicePreviewRibbon } from '@features/invoices/elements/InvoicePreviewRibbon'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useInvoicePreview } from '@features/invoices/hooks/useInvoicePreview'

import { useRecurringInvoice } from '../../contexts/recurringInvoiceContext'
import { useFetchRecurringInvoiceDraftFormat } from '../../hooks/useFetchRecurringInvoiceDraftFormat'
import * as Styled from './styles'

export const RecurringInvoicePreview = (): ReactElement => {
  const { t } = useTranslation()
  const { recurringInvoiceId } = useRecurringInvoice()
  const { recurringInvoice, isLoading: isLoadingPreviewPayloadData } =
    useFetchRecurringInvoiceDraftFormat(recurringInvoiceId)

  const { htmlFiles, isLoading: isLoadingPreview } = useInvoicePreview({
    invoiceDraftPayload: recurringInvoice?.draft,
    documentType: InvoiceDocumentType.RecurringInvoice,
  })

  const isLoading = isLoadingPreviewPayloadData || isLoadingPreview

  return (
    <Styled.RecurringInvoiceHtmlPreviewWrapper>
      <InvoicePreviewRibbon text={t('recurring_invoices.page.preview.ribbon.label')} variant="black" />
      <Flex justifyContent="center">
        <DocumentHtmlPreview htmlFiles={htmlFiles} isLoading={isLoading} />
      </Flex>
    </Styled.RecurringInvoiceHtmlPreviewWrapper>
  )
}
